import React, { useState } from "react";
const axios = require("axios");
const constants = require("../../../constant");

function Addleaveform() {
    const [startDate, setStartDate] = useState(Date.now());
    const [endDate, setEndDate] = useState(Date.now());
    const [numberOfDays, setNumberOfDays] = useState(0);
    const [leaveLetter, setLeaveLetter] = useState(null);
    const [typeOfLeave, setTypeOfLeave] = useState("");
    const [desc, setDesc] = useState("");
    const diffDays = (date, otherDate) => {
        const date1 = new Date(date);
        const date2 = new Date(otherDate);
        setNumberOfDays(
            Math.ceil(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
        );
    };
    return (
        <>
            <div className="main-container">
                <div className="pd-ltr-20 xs-pd-20-10">
                    <div
                        className="remainingLeaves"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <div className="row">
                            <h1
                                style={{
                                    fontSize: "1.5rem",
                                }}
                            >
                                Available Sick leaves:
                            </h1>
                            <p
                                style={{
                                    fontSize: "4rem",
                                    fontWeight: "bold",
                                    color: "green",
                                }}
                            >
                                12
                            </p>
                        </div>
                        <div className="row">
                            <h1 style={{ fontSize: "1.5rem" }}>
                                Available Casual leaves:
                            </h1>
                            <p
                                style={{
                                    fontSize: "4rem",
                                    fontWeight: "bold",
                                    color: "red",
                                }}
                            >
                                15
                            </p>
                        </div>
                        <div className="row">
                            <h1 style={{ fontSize: "1.5rem" }}>
                                Available Earned leaves:
                            </h1>
                            <p
                                style={{
                                    fontSize: "4rem",
                                    fontWeight: "bold",
                                    color: "purple",
                                }}
                            >
                                5
                            </p>
                        </div>
                        <div className="row">
                            <h1 style={{ fontSize: "1.5rem" }}>
                                Available Maternity leaves:
                            </h1>
                            <p
                                style={{
                                    fontSize: "4rem",
                                    fontWeight: "bold",
                                    color: "brown",
                                }}
                            >
                                11
                            </p>
                        </div>
                    </div>
                    <div className="min-height-200px">
                        <div className="page-header">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="title">
                                        <h4>Add Leaves</h4>
                                    </div>
                                    <nav
                                        aria-label="breadcrumb"
                                        role="navigation"
                                    >
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li className="breadcrumb-item">
                                                Leaves
                                            </li>
                                            <li
                                                className="breadcrumb-item active"
                                                aria-current="page"
                                            >
                                                Add Leaves
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div className="pd-20 card-box mb-30">
                            <div className="wizard-content">
                                <form className="tab-wizard wizard-circle wizard">
                                    <section>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>From-Date :</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Select From Date"
                                                        value={startDate}
                                                        onChange={(e) => {
                                                            setStartDate(
                                                                e.target.value
                                                            );
                                                            diffDays(
                                                                startDate,
                                                                endDate
                                                            );
                                                            console.log(
                                                                startDate
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>To-Date :</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Select From Date"
                                                        value={endDate}
                                                        onChange={(e) => {
                                                            setEndDate(
                                                                e.target.value
                                                            );
                                                            diffDays(
                                                                startDate,
                                                                endDate
                                                            );
                                                            console.log(
                                                                endDate
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Number of Days :
                                                    </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={numberOfDays}
                                                        onChange={(e) => {
                                                            setNumberOfDays(
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 ">
                                                <div class="form-group">
                                                    <label>Upload File</label>
                                                    {/* <div class="custom-file ">
                                                        <input
                                                            type="file"
                                                            class="custom-file-input"
                                                        />
                                                        <label class="custom-file-label">
                                                            Choose file
                                                        </label>
                                                    </div> */}
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        placeholder="Enter title of training"
                                                        // value={leaveLetter}
                                                        onChange={(e) => {
                                                            try {
                                                                console.log(
                                                                    e.target
                                                                        .files[0]
                                                                );
                                                                setLeaveLetter(
                                                                    e.target
                                                                        .files[0]
                                                                );
                                                            } catch (err) {
                                                                console.log(
                                                                    err
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>
                                                        Type of Leave :
                                                    </label>
                                                    <select
                                                        className="custom-select form-control"
                                                        value={typeOfLeave}
                                                        onChange={(e) => {
                                                            setTypeOfLeave(
                                                                e.target.value
                                                            );
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Leave
                                                        </option>
                                                        <option value="Sick Leave">
                                                            Sick Leave
                                                        </option>
                                                        <option value="Casual Leave">
                                                            Casual Leave
                                                        </option>
                                                        <option value="Earned Leave">
                                                            Earned Leave
                                                        </option>
                                                        <option value="Maternity Leave">
                                                            Maternity Leave
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Reason :</label>
                                                    <textarea
                                                        className="form-control"
                                                        value={desc}
                                                        onChange={(e) => {
                                                            setDesc(
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-12 col-form-label"></label>
                                            <div className="col-sm-12 col-md-10">
                                                <input
                                                    className="btn btn-primary"
                                                    type="submit"
                                                    // defaultValue={desc}
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        console.log(
                                                            startDate,
                                                            endDate,
                                                            numberOfDays,
                                                            typeOfLeave,
                                                            desc,
                                                            leaveLetter
                                                        );
                                                        const formData =
                                                            new FormData();
                                                        formData.append(
                                                            "startDate",
                                                            startDate
                                                        );
                                                        formData.append(
                                                            "endDate",
                                                            endDate
                                                        );
                                                        formData.append(
                                                            "numberOfDays",
                                                            numberOfDays
                                                        );
                                                        formData.append(
                                                            "typeOfLeave",
                                                            typeOfLeave
                                                        );
                                                        formData.append(
                                                            "desc",
                                                            desc
                                                        );
                                                        formData.append(
                                                            "leaveLetter",
                                                            leaveLetter
                                                        );
                                                        formData.append(
                                                            "token",
                                                            localStorage.getItem(
                                                                "token"
                                                            )
                                                        );
                                                        const result =
                                                            await axios({
                                                                method: "post",
                                                                url: `${constants.backendUrl}/addLeaves`,
                                                                data: formData,
                                                                headers: {
                                                                    "Content-Type":
                                                                        "multipart/form-data",
                                                                },
                                                            });
                                                        console.log(result);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </section>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Addleaveform;
